export default "__VITE_ASSET__90e55daa__"